import React from 'react';
import { Link } from 'react-router-dom';
import { AuthShell, AuthBanner } from '../components/AuthShell';

/**
 * Landing page for users whose workspace has been suspended (or whose
 * account has been deactivated) mid-session. The api client redirects here
 * on a 403 with error code `workspace_suspended` / `inactive`. The session
 * token is already cleared by the time the user lands here.
 */
export function Suspended() {
  return (
    <AuthShell
      title="Workspace unavailable"
      footer={
        <span className="muted">
          <Link to="/login">Back to sign in</Link>
        </span>
      }
    >
      <AuthBanner kind="error">
        Your workspace is currently unavailable. This usually means it has been
        suspended by the platform operator, or your account has been deactivated.
        Please reach out to your workspace admin or the platform operator.
      </AuthBanner>
    </AuthShell>
  );
}
